export default {
	name: 'partner',
	title: 'Partner',
	type: 'object',
	fields: [
		{
			name: 'name',
			title: 'Partner Name',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'logo',
			title: 'Partner Logo',
			type: 'image',
			options: {
				hotspot: true,
			},
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'website',
			title: 'Partner Website',
			type: 'url',
		},
	],
};
